import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Class } from 'src/interfaces/class.types';
import { UserClassesState } from 'src/interfaces/store.types';
import type { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: UserClassesState = {
  selectedClass: undefined,
  activeUserClasses: undefined,
};

export const userClassesSlice = createSlice({
  name: 'userClasses',
  initialState,
  reducers: {
    setSelectedClass: (state, action: PayloadAction<Class[] | null>) => {
      state.selectedClass = action.payload;
    },
    setActiveUserClasses: (state, action: PayloadAction<Class[]>) => {
      state.activeUserClasses = action.payload;
    },
  },
});

export const { setSelectedClass, setActiveUserClasses } =
  userClassesSlice.actions;

export const useSelectedClassSelector = () =>
  useAppSelector((state: RootState) => state.userClasses.selectedClass);

export const useActiveUserClassesSelector = () =>
  useAppSelector((state: RootState) => state.userClasses.activeUserClasses);

export default userClassesSlice.reducer;
